export default __webpack_public_path__ + "static/media/g3.66c2831c.PNG";